import { packageVarsConsumer } from '@epihub/core/src/env';
import { z } from 'zod/v4';
import { Process } from '@epihub/core/src/process/Process';
import { expectNotEmpty } from '@epihub/core/src/fn/string';
import { packageConst } from './package';
import { log } from './log';

export const vars = packageVarsConsumer({
  packageConst,
  parser: z.object({}),
});

export function getAppDomains() {
  expectNotEmpty(Process.env.ENVIRONMENT);
  expectNotEmpty(Process.env.BRANCH);
  function getBaseDomain() {
    if (Process.env.ENVIRONMENT === 'local') {
      return 'krishanmadan.local';
    }

    if (Process.env.BRANCH === 'main' && Process.env.ENVIRONMENT === 'production') {
      return 'krishanmadan.com';
    }

    return `krishanmadan-${Process.env.ENVIRONMENT}-${Process.env.BRANCH}.krishanmadan.com`;
  }

  const baseDomain = getBaseDomain();
  const domains = {
    cookies: baseDomain,
    frontend: baseDomain,
    backend: `api.${baseDomain}`,
  };
  log.i('vars::getAppDomains', 'cors domains', domains);
  return domains;
}
